import LayoutHR from "layouts/layout-hr";
import React from "react";
import { useNavigate } from "react-router-dom";
import { URLS } from "utils/constants";
import { IconCalendarEvent, IconCurrencyDollar } from "@tabler/icons-react";

const SettingPage = () => {
  const navigate = useNavigate();

  const menuItems = [
    // {
    //   title: "Attendance Settings",
    //   description: "Configure attendance policies and rules",
    //   icon: IconCalendarEvent,
    //   path: URLS.v1.HR_SETTING_ATTENDANCE,
    //   color: "primary",
    // },
    {
      title: "Salary Settings",
      description: "Configure salary structures and calculations",
      icon: IconCurrencyDollar,
      path: URLS.v1.HR_SETTING_SALARY,
      color: "success",
    },
  ];

  return (
    <LayoutHR>
      <div className="container-xl">
        {/* Page Header */}
        <div className="page-header d-print-none">
          <div className="row align-items-center">
            <div className="col">
              <h2 className="page-title">HR Settings</h2>
              <div className="text-muted mt-1">
                Configure HR system settings and policies
              </div>
            </div>
          </div>
        </div>

        {/* Menu Cards */}
        <div className="row row-deck row-cards">
          {menuItems.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <div key={index} className="col-sm-6 col-lg-6 mb-4">
                <div className="card card-hover">
                  <div className="card-body text-center">
                    <div
                      className={`avatar avatar-xl mb-3 bg-${item.color}-lt`}
                    >
                      <IconComponent
                        size={32}
                        className={`text-${item.color}`}
                      />
                    </div>
                    <h3 className="card-title mb-2">{item.title}</h3>
                    <p className="text-muted mb-3">{item.description}</p>
                    <button
                      className={`btn btn-${item.color} w-100`}
                      onClick={() => navigate(item.path)}
                    >
                      Configure 
                      {/* {item.title} */}
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </LayoutHR>
  );
};

export default SettingPage;